import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Invoice from '../../models/Invoice'

export interface InvoiceListState extends PaginatedApiState {
  invoices?: Invoice[]
}

const InvoiceList = (state: InvoiceListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<InvoiceListState>('INVOICE_LIST')(state, action)
  }
}

export default InvoiceList
